import { useQuery } from "@tanstack/react-query";

import { libroMayorService } from "~/services/contabilidad/libroMayorService";
import type { LibroMayorFilters } from "~/types/contabilidad";

export const LIBRO_MAYOR_QUERY_KEY = ["libro-mayor"];

export function useLibroMayor(filters: LibroMayorFilters) {
  return useQuery({
    queryKey: [...LIBRO_MAYOR_QUERY_KEY, filters],
    queryFn: () => libroMayorService.getLibroMayor(filters),
    enabled: !!filters.dateFrom && !!filters.dateTo && !!filters.companyId,
  });
}
